export default __webpack_public_path__ + "static/media/logo-garuda-hd-34025.cdb0ed7f.png";